import React, { useReducer } from "react";
import axios from "axios";
import AdminRegistrationContext from "./adminRegistrationContext";
import AdminRegistrationReducer from "./adminRegistrationReducer";
import setAuthToken from "../../functions/auth_header";
import ErrorLogger from "../../components/ErrorLogger";

import {
  GET_ENROLLMENT_SITES,
  GET_REGISTRATIONS,
  GET_REGISTRATION,
  CLEAR_REGISTRATION,
  UPDATE_REGISTRATION,
  DELETE_REGISTRATION,
  AGE_FILTER,
  SEARCH_FILTER,
  SEARCH_FILTERLELO,
  CLEAR_AGE_FILTER,
  CLEAR_SEARCH_FILTER,
  CLEAR_SEARCH_FILTERLELO,
  SET_LIST_VIEW,
  FILTER_TABLE,
  CLEAR_FILTER_TABLE,
  SET_FORM_MODAL,
  FILTER_ENROLLMENT_SITES,
  CLEAR_FILTER_ENROLLMENT_SITES,
  GET_LELOREGISTRATIONS,
  ADD_LELO,
  UPDATE_LELO,
  GET_COURSEOPTIONCATALOG,
  GET_COURSEOPTIONCATALOGID,
  GET_COURSECATALOG,
  GET_REGISTRATION_ENTRIES,
  SET_LOADING_REG,
  SET_CURRENT_PAGE,
} from "../types";
import { getAppUrl, getLocationApiUrl } from "../../functions/getEnv";

const AdminState = (props) => {
// Add sidebar management functions
  const toggleSidebar = () => {
    try {
      dispatch({ type: "TOGGLE_SIDEBAR" });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const setSidebar = (isOpen) => {
    try {
      dispatch({ type: "SET_SIDEBAR", payload: isOpen });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };





  const initialState = {
    formData: {
      // Add sidebar state
      sidebarOpen: true,
      progressLevel: 0,
      processingLevel: 0,
      status: "",
      registerForIntercession: false,
      previouslyEnrolled: "",
      firstName: "",
      middleName: "",
      lastName: "",
      haveSuffix: { yes: false, no: false },
      suffix: "",
      gender: "",
      birthDate: "",
      age: "",
      gradeLevel: "",
      birthState: "",
      birthCountry: "",
      studentEmail: "",
      studentPrimaryPhone: "",
      studentPrimaryPhoneType: "",
      pgHighestLevelOfEducation: "",
      permissionParentContact: { yes: false, no: false },
      pgRelationshipToStudent: "",
      pgFirstName: "",
      pgLastName: "",
      pgPrimaryPhone: "",
      pgPrimaryPhoneType: "",
      pgPrimaryEmail: "",
      liveWithPg: "",
      livingStatus: "",
      street: "",
      city: "",
      state: "",
      zip: "",
      county: "",
      isMailingAddressTheSame: { yes: false, no: false },
      mailingStreet: "",
      mailingCity: "",
      mailingState: "",
      mailingZip: "",
      isStudentHispanicOrLatino: { yes: false, no: false },
      primaryRaceCategory: "",
      previousSchool: "",
      previousSchoolCity: "",
      previousSchoolState: "",
      primaryLanguage: "",
      firstLanguage: "",
      homeLanguage: "",
      languageSpokenByParentsToStudent: "",
      languageSpokenByAdultsAtHome: "",
      isPgEmployedInOneOrMoreAgriculturalOrFishingActivities: {
        yes: true,
        no: false,
      },
      releaseAudioAndVideo: { yes: false, no: false },
      releasePermissionForSocialMedia: { yes: false, no: false },
      releaseUseStudentWork: { yes: false, no: false },
      releasePermissionToTextStudent: { yes: false, no: false },
      releasePermissionToTextPg: { yes: false, no: false },
      releaseAllowStudentAccessToGoogleAppsForEducation: {
        yes: false,
        no: false,
      },
      beenExpelled: { yes: false, no: false },
      expelledFromWhichSchool: "",
      expelledWhatYear: "",
      beenSuspended: { yes: false, no: false },
      suspendedFromWhichSchool: "",
      suspendedWhatYear: "",
      onProbation: { yes: false, no: false },
      isParentOrExpecting: { yes: false, no: false },
      moreThanThreeUnexcusedAbsences: { yes: false, no: false },
      lateToSchoolMoreThanThreeTimes: { yes: false, no: false },
      orderedToAttendSchool: { yes: false, no: false },
      orderedToAttendWhichSchool: "",
      orderedToAttendWhatYear: "",
      retainedMoreThanOnce: { yes: false, no: false },
      retainedFromWhichSchool: "",
      retainedFromWhatYear: "",
      droppedOutOfSchool: { yes: false, no: false },
      droppedOutFromWhichSchool: "",
      droppedOutFromWhatYear: "",
      behindSemesterInCredits: { yes: false, no: false },
      outOfSchoolMoreThanFortyFiveDays: { yes: false, no: false },
      expelledMoreThanTwoSchoolsPastYear: { yes: false, no: false },
      fosterCare: { yes: false, no: false },
      youthExperiencingHomelessness: { yes: false, no: false },
      accessToComputerAtHome: { yes: false, no: false },
      accessToTheInternetAtHome: { yes: false, no: false },
      knownHealthConditions: { yes: false, no: false },
      asthma: { yes: false, no: false },
      beeStingAllergy: { yes: false, no: false },
      diabetes: { yes: false, no: false },
      epilepsy: { yes: false, no: false },
      heartCondition: { yes: false, no: false },
      seizures: { yes: false, no: false },
      nutAllergy: { yes: false, no: false },
      knownHearingConditions: { yes: false, no: false },
      wearsHearingAid: { yes: false, no: false },
      knownEyeCondition: { yes: false, no: false },
      glassesToBeWornAtAllTimes: { yes: false, no: false },
      wearsContactLenses: { yes: false, no: false },
      wearsGlasses: { yes: false, no: false },
      medications: "",
      otherHealthCondition: "",
      medicalInstructions: "",
      heathInsuranceCarrier: "",
      insuranceIdOrPolicyNumber: "",
      hospitalPreference: "",
      custodyIssueExists: { yes: false, no: false },
      custodyIssueNotes: "",
      legalRestrictionsForAnyParent: { yes: false, no: false },
      legalRestrictionsNotes: "",
      emergencyContact1FirstName: "",
      emergencyContact1LastName: "",
      emergencyContact1Phone: "",
      emergencyContact1Relationship: "",
      authorizedForPickup1: { yes: false, no: false },
      emergencyContact2FirstName: "",
      emergencyContact2LastName: "",
      emergencyContact2Phone: "",
      emergencyContact2Relationship: "",
      authorizedForPickup2: { yes: false, no: false },
      learningCenterName: "",
      learningCenterCharter: "",
      learningCenterAddress: "",
      learningCenterCoordinates: "",
      learningCenterId: "",
      orientationScheduled: false,
      orientationType: "",
      orientationTime: "",
      orientationLink: "",
    },
    searchSites: [],
    filteresSearchSites: [],
    allRegistrations: [],
    completedRegistrations: [],
    terminatedRegistrations: [],
    registrations: [],
    scheduledOrientations: [],
    registration: {},
    filteredRegistrations: [],
    ageFiltered: [],
    enrollmentFiltered: [],
    searchFiltered: [],
    LeloRegistrations: [],
    CourseCatalog: [],
    filteredLELORegistrations: null,
    CourseOptionCatalog: [],
    CourseOptionCatalogID: [],
    ageOver: false,
    ageUnder: false,
    listView: true,
    regularEnrollmentOnly: false,
    intercessionEnrollmentOnly: false,
    studentMatchResults: [],
    studentMatchLoading: false,
    formModal: {
      siteZipSearchModal: false,
      siteFieldSearchModal: false,
      studentMatchModal: false,
      orientationModal: false,
      confirmModal: false,
      postRegistrationModal: false,
      processRegistrationModal: false,
      specialProgramsModal: false,
      terminateEnrollmentModal: false,
    },
    statusTypes: [],
    sortOptions: {
      createdAt: { asc: false, desc: false },
      age: { asc: false, desc: false },
      firstName: { asc: false, desc: false },
      status: { asc: false, desc: false },
      registerForIntercession: { asc: false, desc: false },
      studentEmail: { asc: false, desc: false },
      studentPrimaryPhone: { asc: false, desc: false },
      learningCenterName: { asc: false, desc: false },
    },
    orientationSortOptions: {
      action: { asc: false, desc: false },
      orientationTime: { asc: false, desc: false },
      age: { asc: false, desc: false },
      firstName: { asc: false, desc: false },
      status: { asc: false, desc: false },
      registerForIntercession: { asc: false, desc: false },
      learningCenterName: { asc: false, desc: false },
      programs: { asc: false, desc: false },
      moreInfo: { asc: false, desc: false },
    },
    sidebarStatus: {
      forms: false,
      actions: false,
      setup: false,
    },
    validationCheck: false,
    selectedSite: {},
    Siteprogram: {},
    loading: true,
    orientation_info: {},
    notificationBanner: {
      visible: false,
      type: "",
      message: "",
    },
    registrationListStatus: {
      regular: true,
      completed: false,
      terminated: false,
    },
    // Pagination state
    currentPage: 1,
    searchText: "",
    pageSize: 300,
    totalCount: 0,
    appliedFilters: {},
    currentFilters: {
      charterName: null,
      learningCenterName: null,
      status: null,
      age: null,
      searchText: null,
      startDate: null,
      endDate: null,
      allTime: false,
    },
    visibleColumns: {
      createdAt: true,
      status: true,
      learningCenterName: true,
      enrollmentType: true,
      studentFirstName: true,
      age: true,
      phone: true,
      primaryEmail: true,
    },
  };

  const [state, dispatch] = useReducer(AdminRegistrationReducer, initialState);

  /* const apiUrl =
    import.meta.env.MODE === `production` ? `` : `http://localhost:5000`; */

  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
  const locationApiUrl = getLocationApiUrl(import.meta.env.VITE_NODE_ENV);


  const onFormDataChange = (e) => {
    dispatch({
      type: "ON_FORM_DATA_CHANGE",
      payload: {
        name: e.target.name,
        value:
          e.target.type === "radio"
            ? e.target.name === "previouslyEnrolled"
              ? e.target.value === "yes"
                ? { yes: true, no: false, "not sure": false }
                : e.target.value === "no"
                ? { yes: false, no: true, "not sure": false }
                : { yes: false, no: false, "not sure": true }
              : e.target.value === "yes"
              ? { yes: true, no: false }
              : { yes: false, no: true }
            : e.target.value,
      },
    });
  };
  const getAge = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var newAge = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      newAge--;
    }
    dispatch({ type: "GET_AGE", payload: newAge });
  };

  const setLanguageToEnglish = () => {
    dispatch({ type: "SET_TO_ENGLISH" });
  };

  const selectEnrollmentType = (type) => {
    dispatch({ type: "SELECT_ENROLLMENT_TYPE", payload: type });
  };

  const setValidationCheck = (value) => {
    dispatch({ type: "SET_VALIDATION", payload: value });
  };

  const addSpecialPrograms = async (formData, id) => {
    try {
      const res = await axios.put(
        `${appUrl}/api/registration/add-special-programs/${id}`,
        formData
      );
      dispatch({ type: "ADD_SPECIAL_PROGRAMS", payload: formData });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const charter = (charters) => {
    try {
      dispatch({ type: "CHARTER", payload: charters });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const registrationStatusUpdate = async (data, type, id) => {
    if (type === "PRE") {
      dispatch({ type: "PRE_REGISTRATION_STATUS_UPDATE", payload: data });
    } else {
      try {
        await axios.put(`${appUrl}/api/registration/status/${id}`, data);
        dispatch({ type: "POST_REGISTRATION_STATUS_UPDATE", payload: data });
      } catch (error) {
        console.error(error.message);
        ErrorLogger.logError(error.message);
      }
    }
  };

  const terminateEnrollment = async (id, notes) => {
    try {
      await axios.put(`${appUrl}/api/registration/terminate/${id}`, { notes });
      dispatch({ type: "TERMINATE_ENROLLMENT", payload: notes });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const setLocationInfo = (data) => {
    dispatch({
      type: "SET_LOCATION_DATA",
      payload: {
        id: data.id,
        name: data.name,
        charter: data.charter,
        address: data.address,
        coordinates: data.coordinates,
      },
    });
  };

  const clearFormData = () => {
    dispatch({ type: "CLEAR_FORM_DATA" });
  };

  const handleToggleMenu = (type) => {
    dispatch({ type: "TOGGLE_SUB_MENU", payload: type });
  };

  const handleBatchStatusUpdate = async (items) => {
    let formIds = [];
    await items.selectedItems.map((form) => {
      formIds.push(form._id);
    });
    try {
      await axios.patch(
        `${appUrl}/api/registration/batch-status-update`,
        items
      );
      dispatch({ type: "BATCH_STATUS_UPDATE", payload: formIds });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const getSearchSites = async () => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const res = await axios.get(
        `${
          locationApiUrl
          /* process.env.NODE_ENV === `production`
            ? `https://llac-locations-api.azurewebsites.net`
            : `http://localhost:7000` */
        }/enrollment-sites`
      );
      dispatch({ type: GET_ENROLLMENT_SITES, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const filterSearchSites = async (text) => {
    try {
      dispatch({ type: FILTER_ENROLLMENT_SITES, payload: text });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const clearfilteredSearchSites = async () => {
    try {
      dispatch({ type: CLEAR_FILTER_ENROLLMENT_SITES });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const setCurrentPage = (page) => {
    dispatch({ type: SET_CURRENT_PAGE, payload: page });
  };

  const toggleColumn = (columnName) => {
    dispatch({ type: "TOGGLE_COLUMN", payload: columnName });
  };

  const getRegistrations = async ({
    learningCenterCharter,
    learningCenterName,
    status,
    age,
    page = 1,
    pageSize = 300,
    searchText,
    startDate,
    endDate,
    allTime = false
  } = {}) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      dispatch({ type: SET_LOADING_REG });

      const params = new URLSearchParams();

      // Charter filter
      if (learningCenterCharter && learningCenterCharter !== "all") {
        params.append("learningCenterCharter", learningCenterCharter);
      }

      // Learning Center filter
      if (learningCenterName && learningCenterName !== "all") {
        params.append("learningCenterName", learningCenterName);
      }

      // Status filter
      if (status && status !== "all") {
        params.append("status", status);
      }

      // Age filter
      if (age && age !== "all") {
        params.append("age", age);
      }

      // Search filter
      if (searchText) params.append("search", searchText);

      // Date range filters
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      if (allTime) params.append("allTime", allTime);

      // Pagination
      params.append("page", page);
      params.append("pageSize", pageSize);

      // Perform GET request
      const apiUrl = `${appUrl}/api/registration?${params.toString()}`;
      const response = await axios.get(apiUrl);

      dispatch({
        type: GET_REGISTRATION_ENTRIES,
        payload: response.data.data || response.data.regularRegistrations,
        totalCount: response.data.total_count || response.data.regularRegistrations?.length || 0,
        appliedFilters: response.data.applied_filters || {},
        allRegistrations: response.data.allRegistrations,
        learningCenterCharter,
        learningCenterName,
        status,
        age,
        page,
        pageSize,
        searchText,
        startDate,
        endDate,
        allTime
      });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const getLeloRegistrations = async () => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const res = await axios.get(`${appUrl}/api/sessions`);
      dispatch({
        type: GET_LELOREGISTRATIONS,
        payload: res.data,
      });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const addLELO = async (data) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const res = await axios.post(`${appUrl}/api/sessions`, data);
      dispatch({ type: ADD_LELO, payload: res.data });
    } catch (err) {
      console.error(err.message);
      ErrorLogger.logError(err.message);
    }
  };

  const updateLELO = async (id, data) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const res = await axios.put(`${appUrl}/api/sessions/${id}`, data);
      dispatch({ type: UPDATE_LELO, payload: res.data });
    } catch (err) {
      console.error(err.message);
      ErrorLogger.logError(err.message);
    }
  };

  const getCourseOptionCatalog = async () => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const res = await axios.get(`${appUrl}api/courseCatalogOptions`);
  
      dispatch({
        type: GET_COURSEOPTIONCATALOG,
        payload: res.data,
      });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const getCourseOptionCatalogID = async (charter_id) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }

      // Set withCredentials to false for external Graph API call
      axios.defaults.withCredentials = false;

      const res = await axios.get(
        `https://api.llac.io/api/v1/config/course_catalog_options?charter_id=${charter_id}`,
        {
          headers: {
            "x-functions-key": "EqYg_WkZwwovAVTKf77bco1UJjkzxmviAbJXhiXtxwEvAzFuWvAQ1A==",
          },
        }
      );

      // Reset withCredentials to true after external API call
      axios.defaults.withCredentials = true;

      // Log the response data

        dispatch({
          type: GET_COURSEOPTIONCATALOGID,
          payload: res.data.data,
        });


    } catch (error) {
      // Reset withCredentials to true in case of error
      axios.defaults.withCredentials = true;
      console.error('Error:', error.message);
      ErrorLogger.logError(error.message);
    }
  };
  
  const fetchCourseCatalogOptions = async (siteId ) => {
    try {
      // Validate siteId before making API call
      if (!siteId || siteId === "undefined" || siteId === "null") {
        console.warn("Invalid siteId provided to fetchCourseCatalogOptions");
        return;
      }

      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const res = await axios.get(`${appUrl}/api/courses/${siteId}`);
      dispatch({
        type: GET_COURSECATALOG,
        payload: res.data,
      });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const updateRegisrationListStatus = (type) => {
    try {
      dispatch({ type: "UPDATE_REGISTRATION_LIST_STATUS", payload: type });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const getScheduledOrientations = async () => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const res = await axios.get(`${appUrl}/api/registration/orientations`);
      dispatch({ type: "GET_SCHEDULED_ORIENTATIONS", payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const getRegistration = async (id) => {
    try {
      const res = await axios.get(`${appUrl}/api/registration/${id}`);
      dispatch({ type: GET_REGISTRATION, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const updateRegistration = async (id, data) => {
    try {
      const res = await axios.put(`${appUrl}/api/registration/${id}`, data);
      dispatch({ type: UPDATE_REGISTRATION, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const deleteRegistration = async (id) => {
    try {
      const res = await axios.delete(`${appUrl}/api/registration/${id}`);
      dispatch({ type: DELETE_REGISTRATION, payload: id });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const ageFilter = async (type) => {
    try {
      dispatch({ type: AGE_FILTER, payload: type });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const enrollmentFilter = async (type) => {
    try {
      dispatch({ type: "ENROLLMENT_FILTER", payload: type });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const searchFilter = async (text) => {
    try {
      // Update search text in state
      dispatch({ type: "SET_SEARCH_TEXT", payload: text });

      // Call API with search text and current filters
      await getRegistrations({
        ...state.currentFilters,
        searchText: text,
        page: 1 // Reset to first page when searching
      });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const searchFilterLelo = async (text) => {
    try {
      dispatch({ type: SEARCH_FILTERLELO, payload: text });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const clearStatusFilter = () => {
    try {
      dispatch({ type: "CLEAR_STATUS_FILTER" });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const clearAgeFilter = () => {
    try {
      dispatch({ type: CLEAR_AGE_FILTER });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const clearEnrollmentFilter = () => {
    try {
      dispatch({ type: "CLEAR_ENROLLMENT_FILTER" });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const clearSearchFilter = async () => {
    try {
      // Clear search text in state
      dispatch({ type: "SET_SEARCH_TEXT", payload: "" });

      // Call API without search text
      await getRegistrations({
        ...state.currentFilters,
        searchText: "",
        page: 1
      });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const clearSearchFilterLelo = () => {
    try {
      dispatch({ type: CLEAR_SEARCH_FILTERLELO });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const clearRegistration = async () => {
    try {
      dispatch({ type: CLEAR_REGISTRATION });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const setListView = (value) => {
    try {
      dispatch({ type: SET_LIST_VIEW, payload: value });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const onTableFilter = (value) => {
    try {
      dispatch({ type: FILTER_TABLE, payload: value });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const onOrientationTableFilter = (value) => {
    try {
      dispatch({ type: "FILTER_ORIENTATION_TABLE", payload: value });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const clearTableFilter = () => {
    try {
      dispatch({ type: CLEAR_FILTER_TABLE });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const setFormModal = (name, value) => {
    try {
      dispatch({ type: SET_FORM_MODAL, payload: { name, value } });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const getStudentMatchResults = async (studentData) => {
    dispatch({ type: "SET_MATCH_LOADING" });
    try {
      const res = await axios.post(
        `${appUrl}/api/sql/student-match`,
        studentData
      );
      dispatch({
        type: "GET_STUDENT_MATCH",
        payload: res.data.recordset,
      });
    } catch (error) {
      dispatch({ type: "STUDENT_MATCH_ERROR" });
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const clearStudentMatchResults = () => {
    dispatch({ type: "CLEAR_STUDENT_MATCH_RESULTS" });
  };

  const getStatusTypes = async () => {
    try {
      const res = await axios.get(`${appUrl}/api/status_types/`);
      dispatch({ type: "GET_STATUS_TYPES", payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const sendOrientationEmail = async (formData, type, order) => {
    const route =
      type === "VIRTUAL" ? "virtual-orientation" : "live-orientation";
    try {
      await axios.post(`${appUrl}/api/email/${route}`, formData);
      dispatch({
        type: order === "POST" ? "POST_SCHEDULE_ORIENTATION" : "SET_ALERT",
        payload: { msg: "Orientation Email Sent", msgType: "success" },
      });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const completeEnrollmentEmail = async (formData) => {
    const { name } = formData;
    try {
      await axios.post(`${appUrl}/api/email/final-enrollment`, formData);
      dispatch({
        type: "SET_ALERT",
        payload: { msg: `${name}'s Enrollment Completed`, msgType: "success" },
      });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const getOrientationInformation = async (id) => {
    try {
      // Validate ID before making API call
      if (!id || id === "undefined" || id === "null") {
        console.warn("Invalid learning center ID provided to getOrientationInformation");
        return;
      }

      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const res = await axios.get(
        `${
          locationApiUrl
          /* process.env.NODE_ENV === `production`
            ? `https://llac-locations-api.azurewebsites.net`
            : `http://localhost:7000` */
        }/orientations/${id}`
      );
      dispatch({ type: "GET_ORIENTATION_INFO", payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const closeNotificationBanner = () => {
    dispatch({ type: "CLOSE_NOTIFICATION_BANNER" });
  };

  const updateFormStatus = (newStatus) => {
    dispatch({ type: "UPDATE_FORM_STATUS", payload: newStatus });
  };

  const updateProcessingLevel = (level) => {
    dispatch({ type: "UPDATE_PROCESSING_LEVEL", payload: level });
  };

  const updateRegistrationForm = async (id, formData) => {
    try {
      const res = await axios.put(`${appUrl}/api/registration/${id}`, formData);

      dispatch({ type: "UPDATE_REGISTRATION_FORM", payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const setNotificationBanner = (type, message) => {
    try {
      dispatch({ type: "SET_ALERT", payload: { msgType: type, msg: message } });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const transferInterestToRegistration = (data) => {
    try {
      dispatch({ type: "TRANSFER_INTEREST_TO_REGISTRATION", payload: data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  return (
    <AdminRegistrationContext.Provider
      value={{
        formData: state.formData,
        searchSites: state.searchSites,
        filteresSearchSites: state.filteresSearchSites,
        scheduledOrientations: state.scheduledOrientations,
        registrations: state.registrations,
        allRegistrations: state.allRegistrations,
        LeloRegistrations: state.LeloRegistrations,
        CourseOptionCatalog: state.CourseOptionCatalog,
        CourseOptionCatalogID: state.CourseOptionCatalogID,
        CourseCatalog: state.CourseCatalog,
        filteredLELORegistrations: state.filteredLELORegistrations,
        completedRegistrations: state.completedRegistrations,
        terminatedRegistrations: state.terminatedRegistrations,
        registration: state.registration,
        filteredRegistrations: state.filteredRegistrations,
        ageFiltered: state.ageFiltered,
        enrollmentFiltered: state.enrollmentFiltered,
        searchFiltered: state.searchFiltered,
        ageOver: state.ageOver,
        ageUnder: state.ageUnder,
        charter: state.charter,
        listView: state.listView,
        sortOptions: state.sortOptions,
        orientationSortOptions: state.orientationSortOptions,
        formModal: state.formModal,
        loading: state.loading,
        validationCheck: state.validationCheck,
        regularEnrollmentOnly: state.regularEnrollmentOnly,
        intercessionEnrollmentOnly: state.intercessionEnrollmentOnly,
        studentMatchResults: state.studentMatchResults,
        studentMatchLoading: state.studentMatchLoading,
        statusTypes: state.statusTypes,
        sidebarStatus: state.sidebarStatus,
        orientation_info: state.orientation_info,
        notificationBanner: state.notificationBanner,
        registrationListStatus: state.registrationListStatus,
        currentPage: state.currentPage,
        pageSize: state.pageSize,
        totalCount: state.totalCount,
        searchText: state.searchText,
        appliedFilters: state.appliedFilters,
        currentFilters: state.currentFilters,
        visibleColumns: state.visibleColumns,
        onFormDataChange,
        getAge,
        setLanguageToEnglish,
        selectEnrollmentType,
        clearFormData,
        setLocationInfo,
        getScheduledOrientations,
        getRegistrations,
        setCurrentPage,
        getLeloRegistrations,
        getCourseOptionCatalog,
        fetchCourseCatalogOptions,
        getCourseOptionCatalogID,
        addLELO,
        updateLELO,
        getRegistration,
        clearRegistration,
        updateRegistration,
        deleteRegistration,
        ageFilter,
        searchFilter,
        searchFilterLelo,
        clearAgeFilter,
        clearSearchFilter,
        clearSearchFilterLelo,
        setListView,
        onTableFilter,
        onOrientationTableFilter,
        clearTableFilter,
        setFormModal,
        getSearchSites,
        filterSearchSites,
        clearfilteredSearchSites,
        setValidationCheck,
        enrollmentFilter,
        clearEnrollmentFilter,
        getStudentMatchResults,
        getStatusTypes,
        clearStudentMatchResults,
        handleToggleMenu,
        handleBatchStatusUpdate,
        registrationStatusUpdate,
        sendOrientationEmail,
        getOrientationInformation,
        closeNotificationBanner,
        completeEnrollmentEmail,
        updateFormStatus,
        updateProcessingLevel,
        addSpecialPrograms,
        terminateEnrollment,
        updateRegistrationForm,
        setNotificationBanner,
        updateRegisrationListStatus,
        clearStatusFilter,
        transferInterestToRegistration,
         // Add sidebar state and functions
        sidebarOpen: state.sidebarOpen,
        toggleSidebar,
        setSidebar,
        toggleColumn,
      }}
    >
      {props.children}
    </AdminRegistrationContext.Provider>
  );
};

export default AdminState;
